import { debounce } from 'lodash';
import { computed, defineComponent, ref } from 'vue';
import { LOADING_HEADERS } from '@/constants/headers/loading';
import { ACTIONS_COL } from '@/types/interfaces';
export default defineComponent({
  props: {
    firstRow: {
      type: Boolean,
      default: true
    },
    lastRow: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg'
    },
    columnDefs: {
      type: Object,
      default: () => LOADING_HEADERS()
    }
  },
  setup: (props, {
    emit
  }) => {
    const emitIntersect = debounce((entries, observer, isIntersecting) => {
      if (isIntersecting) {
        emit('intersect');
      }
    }, 500);
    const listRow = ref(null);
    // note: "columns" template is the one we use for when the columns are not specified
    const loaderColumnNames = computed(() => {
      return props.columnDefs.headers.filter(header => header.visibility[props.size] !== 'hide' && header.templateName !== 'columns').map(header => header.templateName);
    });
    return {
      listRow,
      emitIntersect,
      LOADING_HEADERS,
      loaderColumnNames,
      ACTIONS_COL
    };
  }
});